(function () {
  function closePopover(popover, toggle) {
    popover.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAllPopovers() {
    document.querySelectorAll('[data-quick-add-popover]').forEach(function (popover) {
      var toggle = popover.parentElement && popover.parentElement.querySelector('[data-quick-add-toggle]');
      closePopover(popover, toggle);
    });
  }

  // Every size button shares one hidden <product-form> per card (see
  // card-product.liquid) — clicking a size just points that form's
  // variant input at the chosen variant and submits it, so the exact
  // same tested add-to-cart/cart-drawer-open logic (product-form.js)
  // that already handles the single-variant case runs here too.
  function addToCart(sizeButton) {
    var quickAdd = sizeButton.closest('.quick-add');
    if (!quickAdd) return;
    var form = quickAdd.querySelector('[data-quick-add-form]');
    var variantInput = quickAdd.querySelector('[data-quick-add-variant-input]');
    var submitButton = quickAdd.querySelector('.quick-add-hidden-form__submit');
    if (!form || !variantInput || !submitButton) return;

    variantInput.value = sizeButton.dataset.variantId;
    submitButton.click();
  }

  // Hover, driven by JS rather than CSS's @media (hover: hover) — that
  // media feature wasn't matching reliably on every device it was
  // tested on (some laptops with both a trackpad and touch report it
  // ambiguously), so neither the popover nor the tooltip ever showed
  // except via the click fallback below. mouseenter/mouseleave don't
  // depend on that detection at all.
  function initHover(quickAdd) {
    if (quickAdd.dataset.hoverBound) return;
    quickAdd.dataset.hoverBound = 'true';

    var popover = quickAdd.querySelector('[data-quick-add-popover]');
    var tooltip = quickAdd.querySelector('[data-quick-add-tooltip]');
    var toggle = quickAdd.querySelector('[data-quick-add-toggle]');
    var closeTimer = null;

    quickAdd.addEventListener('mouseenter', function () {
      // Cancels any pending close from a moment ago — this is what
      // actually matters: mouseenter/mouseleave don't fire while
      // moving between .quick-add's own descendants (the button and
      // the popover both count), but there's a real visual gap
      // between them (the popover sits slightly below the button),
      // and crossing that gap can pass over unrelated page content
      // in between, triggering a genuine leave/re-enter. Without this
      // grace period that leave closed the popover before the
      // pointer ever reached a size button.
      clearTimeout(closeTimer);
      if (tooltip) tooltip.hidden = false;
      if (popover) {
        popover.hidden = false;
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      }
    });

    quickAdd.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        if (tooltip) tooltip.hidden = true;
        if (popover) closePopover(popover, toggle);
      }, 300);
    });
  }

  // Sections like "Curated Selection" load their product cards via
  // AJAX after the initial page render (<product-recommendations>
  // fetches and injects them with innerHTML), so a one-time scan at
  // page load misses any .quick-add that shows up afterward. This
  // watches the whole document for new ones appearing anywhere and
  // wires them up too, whenever that happens.
  function watchForNewQuickAdds() {
    if (!('MutationObserver' in window)) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.quick-add')) initHover(node);
          if (node.querySelectorAll) node.querySelectorAll('.quick-add').forEach(initHover);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('.quick-add').forEach(initHover);
    watchForNewQuickAdds();

    document.addEventListener('click', function (event) {
      var sizeButton = event.target.closest('[data-quick-add-size]');
      if (sizeButton) {
        addToCart(sizeButton);
        var popover = sizeButton.closest('[data-quick-add-popover]');
        var toggle = popover && popover.parentElement && popover.parentElement.querySelector('[data-quick-add-toggle]');
        closePopover(popover, toggle);
        return;
      }

      var toggle = event.target.closest('[data-quick-add-toggle]');
      if (toggle) {
        var popover = toggle.parentElement && toggle.parentElement.querySelector('[data-quick-add-popover]');
        if (!popover) return;
        var isOpen = !popover.hidden;
        closeAllPopovers();
        if (!isOpen) {
          popover.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      // Click anywhere else — close whatever's open.
      closeAllPopovers();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllPopovers();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
